/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gradelevel_Q22Inputs */

const en__field__enum_gradelevel_q22 = /** @type {(inputs: _Field__Enum_Gradelevel_Q22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q2`)
};

const de__field__enum_gradelevel_q22 = /** @type {(inputs: _Field__Enum_Gradelevel_Q22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q2`)
};

/**
* | output |
* | --- |
* | "Q2" |
*
* @param {_Field__Enum_Gradelevel_Q22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gradelevel_q22 = /** @type {((inputs?: _Field__Enum_Gradelevel_Q22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gradelevel_Q22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gradelevel_q22(inputs)
	return de__field__enum_gradelevel_q22(inputs)
});
export { _field__enum_gradelevel_q22 as "_field__enum_gradeLevel_Q2" }